import React from 'react';
import '../CSS/App.css';
import { NavScroll } from './NavBar';
import SocialLinks from "./SocialLinks";

// EASILY REPLACE YOUR PAYPAL DONATION LINK HERE:
const PAYPAL_DONATION_URL = 'https://paypal.me/YOUR_LINK_HERE';

export default function Donate() {
  const handleSuggestedDonate = (amount) => {
    // Appends the suggested amount to the paypal.me URL (e.g. paypal.me/link/20)
    window.open(`${PAYPAL_DONATION_URL}/${amount}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className='background-component'>
      <NavScroll />

      <div className="donate-container">
        {/* 1. Hero Section */}
        <div className="donate-hero">
          <h1 className="donate-title">Support the LAN</h1>
          <p className="donate-subtitle">
            Help us keep local Halo LAN events running, affordable, and fun.
          </p>
          <a
            href={PAYPAL_DONATION_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="donate-paypal-btn"
          >
            Donate with PayPal
          </a>
        </div>

        {/* 2. Scrollable Body Content */}
        <div className="donate-content-scrollable">

          {/* Suggested Donation Amounts */}
          <div className="donate-section">
            <h2 className="donate-section-title">Suggested Amounts</h2>
            <p className="donate-section-desc">Select an option below to donate that amount via PayPal:</p>
            <div className="donate-amounts-grid">
              <div className="donate-amount-card" onClick={() => handleSuggestedDonate(5)}>
                <span className="donate-amount-value">$5</span>
                <p>Covers cables & adapters</p>
              </div>
              <div className="donate-amount-card" onClick={() => handleSuggestedDonate(10)}>
                <span className="donate-amount-value">$10</span>
                <p>Helps with event supplies</p>
              </div>
              <div className="donate-amount-card" onClick={() => handleSuggestedDonate(20)}>
                <span className="donate-amount-value">$20</span>
                <p>Helps cover venue costs</p>
              </div>
              <div className="donate-amount-card" onClick={() => handleSuggestedDonate(50)}>
                <span className="donate-amount-value">$50</span>
                <p>Big support for future LANs</p>
              </div>
            </div>
          </div>

          {/* Transparency Note */}
          <div className="donate-transparency-note">
            <div className="donate-transparency-icon">🛡️</div>
            <div className="donate-transparency-text">
              <h4>Transparency Promise</h4>
              <p>
                We are a local community-driven league. 100% of all contributions are reinvested directly into equipment, venue costs, prizes, and creating the best possible competitive LAN experience for players. Thank you for supporting the community!
              </p>
            </div>
          </div>

          {/* Alternate Payment Placeholders */}
          <div className="donate-alternates-section">
            <span>Venmo: <strong>Coming Soon</strong></span>
            <span className="donate-divider">|</span>
            <span>Cash App: <strong>Coming Soon</strong></span>
          </div>
        </div>
      </div>

      <SocialLinks />

      <script type="module" src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.esm.js"></script>
      <script nomodule src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.js"></script>
    </div>
  );
}
